export type AffiliateAuthAction = 'login' | 'onboarding';

/** Build affiliate API URL with optional query params (auth via cookies only). */
export function affiliateApiUrl(
  path: string,
  params?: Record<string, string | number | undefined | null>
): string {
  const sp = new URLSearchParams();
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== '') {
        sp.set(key, String(value));
      }
    }
  }
  const qs = sp.toString();
  return qs ? `${path}?${qs}` : path;
}

export async function getAffiliateAuthActionFromResponse(
  res: Response
): Promise<AffiliateAuthAction | null> {
  if (res.status === 401) return 'login';
  if (res.status === 403) {
    try {
      const data = (await res.clone().json()) as { code?: string };
      if (data?.code === 'ONBOARDING_REQUIRED') return 'onboarding';
    } catch {
      // ignore parse errors
    }
  }
  return null;
}

export async function affiliateApiFetch(
  path: string,
  init?: RequestInit,
  params?: Record<string, string | number | undefined | null>
): Promise<Response> {
  return fetch(affiliateApiUrl(path, params), {
    credentials: 'include',
    ...init,
  });
}

/** Creates a new affiliate tenant, selects it in session, returns affiliateId. */
export async function createAffiliateTenant(): Promise<string> {
  const res = await affiliateApiFetch('/api/affiliate/tenants', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  const data = (await res.json().catch(() => ({}))) as {
    affiliateId?: unknown;
    error?: unknown;
  };
  if (!res.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : 'create failed');
  }
  const affiliateId =
    typeof data.affiliateId === 'string' ? data.affiliateId.trim() : '';
  if (!affiliateId) {
    throw new Error('create failed');
  }
  await affiliateApiFetch('/api/affiliate/select', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ affiliateId }),
  });
  return affiliateId;
}
